export default __webpack_public_path__ + "static/media/002.d062c01b.png";